import { Pipe, PipeTransform } from '@angular/core';
import addDays from 'date-fns/addDays';

@Pipe({
  name: 'freeCancellationDate',
  standalone: false
})
export class FreeCancellationDatePipe implements PipeTransform {
  transform(checkinDate: string): Date {
    return addDays(new Date(checkinDate), -2);
  }
}
